<template>
	<span
		class="flex text-gray-100 border border-gray-550 rounded-full"
		:style="{...style, padding: '3px 10px'}"
		data-test="session-label"
	>
		<slot />
	</span>
</template>

<script>
export default {
	name: 'SessionLabelPillContainer',
	props: {
		color: {type: String, default: ''},
	},
	computed: {
		style() {
			if (!this.color) return {}
			return {borderLeftColor: `${this.color} !important`}
		},
	},
}
</script>
